// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.width-wrapper-component {
  max-width: 1366px;
  padding-left: 30px;
  padding-right: 30px;
  margin: 0 auto;
}
@media only screen and (max-width: 768px) {
  .width-wrapper-component {
    padding: 0 15px;
  }
}
.width-wrapper-component.soft {
  background-color: var(--gray_light2);
}`, "",{"version":3,"sources":["webpack://./src/components/WidthWrapper/index.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AADF;AAGE;EANF;IAOI,eAAA;EAAF;AACF;AAEE;EACE,oCAAA;AAAJ","sourcesContent":["@import 'src/vars';\n\n.width-wrapper-component {\n  max-width: 1366px;\n  padding-left: 30px;\n  padding-right: 30px;\n  margin: 0 auto;\n\n  @media only screen and (max-width: $mobile_break) {\n    padding: 0 15px;\n  }\n\n  &.soft {\n    background-color: var(--gray_light2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
